import SongList from "../../components/SongList/SongList";

const SongCollectionPage = () => {
  return <SongList />;
};
export default SongCollectionPage;
